export default __webpack_public_path__ + "static/media/cabourg4.19a8da69.jpg";